// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appId: '7cis5f8rbqchbi8tijitv20sf2',
  amplifyConfig: {
    Auth: {
      region: 'us-east-1',
      userPoolId: 'us-east-1_hx18CNwdz',
      userPoolWebClientId: '7cis5f8rbqchbi8tijitv20sf2',
      identityPoolId: 'us-east-1:22a75788-4d76-4614-8ba6-e5ae58764faf',
    },
    Storage: {
      AWSS3: {
        bucket: 'request-forms',
        region: 'us-east-1',
      },
    },
    API: {
      endpoints: [
        {
          name: 'auth',
          endpoint: 'https://api.hintekkllc.com/v1/auth/',
        },
        {
          name: 'categories',
          endpoint: 'https://api.hintekkllc.com/v1/gtap/categories/',
        },
        {
          name: 'assessments',
          endpoint: 'https://api.hintekkllc.com/v1/gtap/assessments/',
        },
        {
          name: 'goals',
          endpoint: 'https://api.hintekkllc.com/v1/gtap/goals/',
        },
        {
          name: 'goals-categories',
          endpoint: 'https://api.hintekkllc.com/v1/gtap/goal-categories/',
        }
      ],
    },
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

